<template>
    <div v-if="flaggedOffersHeading" class="flagged-offers">
        <h2 class="offer-heading">{{ flaggedOffersHeading }}</h2>
        <div v-for="(offer, index) in flaggedOffers" :key="index" class="offer-block">
            <OfferBlock
                :offer="offer"
                :isAgentPage="isAgentPage"
                :offerCount="flaggedOffers.length"
                :expired="expired"
                :offerIndex="index"
                :loanAmount="loanAmount"
                :loanTerm="loanTerm"
            >
                <OfferContent :loanAmount="loanAmount" :offer="offer" :loanTerm="loanTerm" />
            </OfferBlock>
        </div>
    </div>

    <div v-if="falseFlaggedOffersHeadings" class="false-flagged-offers mt-5">
        <h2 class="offer-heading">{{ falseFlaggedOffersHeadings }}</h2>
        <div v-for="(offer, index) in hasFalseFlaggedOffers" :key="index" class="offer-block">
            <OfferBlock
                :offer="offer"
                :isAgentPage="isAgentPage"
                :offerCount="hasFalseFlaggedOffers.length"
                :expired="expired"
                :offerIndex="index"
                :loanAmount="loanAmount"
                :loanTerm="loanTerm"
            >
                <OfferContent :loanAmount="loanAmount" :offer="offer" :loanTerm="loanTerm" />
            </OfferBlock>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FlaggedOfferBlocks',
    props: [
        'expired',
        'flaggedOffers',
        'flaggedOffersHeading',
        'falseFlaggedOffersHeadings',
        'hasFalseFlaggedOffers',
        'isAgentPage',
        'loanAmount',
        'loanTerm',
    ],
}
</script>

<style lang="scss">
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';

.flagged-offers,
.false-flagged-offers,
.offers-group {
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 10px;

    .offer-heading {
        font-family: var(--heading-font), 'serif';
        font-size: rem(30px);
        font-style: normal;
        font-weight: 600;
        margin-bottom: rem(30px);

        @media screen and (max-width: $bp-small) {
            font-size: rem(20px);
            margin: rem(12.6px);
            text-align: left;
        }
    }
}

.false-flagged-offers {
    padding-bottom: 0;
}
</style>
